import SemiCircularProgress from "../../../sections/admin/lead-requirements/SemiCircularProgress";

const ProfileCompletionCard = () => {
  const percentage = 20;

  return (
    <div className="bg-white w-full shrink-0 p-6 sm:p-8 border border-primary/10 shadow-lg rounded-xl backdrop-blur-lg mx-auto">
      <div className="flex flex-col items-center text-center">
        {/* Semi-circular Gauge - sizing controlled here */}
        <SemiCircularProgress
          percentage={percentage}
          className="w-40 h-20 sm:w-56 sm:h-28 md:w-64 md:h-32 mb-6"
        />

        {/* Labels */}
        <div className="flex flex-col font-poppins">
          <h3 className="text-base sm:text-lg xl:text-xl font-semibold text-[#031722] mb-2">
            Your profile is not <br /> completed yet!
          </h3>
          <p className="text-xs sm:text-sm text-text-muted tracking-wide mb-4">
            Complete it now to gain better visibility, attract more leads, and
            build trust with buyers and sellers.
          </p>
        </div>

        <button
          className="flex items-center justify-center gap-1.5 md:gap-2 bg-btn-brandRed 
          hover:bg-[#FF6A3D] px-3 md:px-4 lg:px-5 py-1.5 sm:py-2 md:py-2 text-white 
          font-medium text-sm shadow-md hover:shadow-lg transform-gpu transition-all duration-100 
          ease-out rounded-full active:scale-[0.97] active:shadow-sm outline-none focus-visible:ring-1
          select-none cursor-pointer"
        >
          <span>Complete Now</span>
        </button>
      </div>
    </div>
  );
};
export default ProfileCompletionCard;
